export default {
  EquipmentIndex: {
    pageTitle: '首页',
    name: '汽车空调清洗回收加注机',
    desc1: '序列号',
    desc2: '型号',
    item1: '使用说明',
    item2: '操作手册',
    item3: '快速入门',
    item4: '售后服务',
    item5: '设备问题与意见',
    desc3: '好意见有奖励'
  },
  EquipmentSuggestion: {
    pageTitle: '设备问题与意见',
    placeholder1: '请描述您的问题或意见，以便我们更好的提供帮助',
    errorMsg1: '输入的文字过长',
    errorMsg2: '问题或意见不能为空',
    title1: '上传图片',
    title2: '联系方式',
    errorMsg3: '联系方式不能为空',
    errorMsg4: '联系方式格式有误',
    placeholder2: '请填写您的手机号',
    placeholder3: '请填写您的邮箱',
    button1: '匿名提交',
    tips: '如提交的意见被采纳，可能获得奖励哦。',
    tips2: '填写联系方式将有机会获得奖励哦',
    button2: '提交意见',
    msg: '提交成功'
  },
  EquipmentSpecification: {
    pageTitle: '使用说明书'
  },
  EquipmentManual: {
    pageTitle: '操作手册'
  },
  EquipmentQuickStart: {
    pageTitle: '快速入门'
  },
  EquipmentASSPolicy: {
    pageTitle: '售后服务政策'
  },
  MyReward: {
    pageTitle: '我的奖励',
    button1: '提现',
    title: '我的余额',
    summary1: '提交意见',
    summary2: '已被采纳',
    summary3: '累计奖励',
    item1: '收入明细',
    item2: '提现账户',
    view: '查看'
  },
  MyRewardList: {
    pageTitle: '我的奖励',
    type1: '提现',
    type2: '意见采纳奖励',
    status1: '成功',
    status2: '失败',
    status3: '进行中',
    noMore: '没有更多数据'
  },
  MyRewardDetail: {
    pageTitle: '详情',
    item1: '类型',
    item2: '时间',
    item3: '状态',
    item4: '失败原因',
    type1: '提现',
    type2: '意见采纳奖励',
    status1: '成功',
    status2: '失败',
    status3: '进行中'
  },
  Account: {
    pageTitle: '支付宝账户',
    title1: '支付宝账户',
    title2: 'PayPal账户',
    placeholder1: '输入姓名(用于转账校验)',
    errorMsg1: '用户名不能为空',
    errorMsg2: '用户名格式有误',
    placeholder2: '输入支付宝账号',
    placeholder3: '输入PayPal账号',
    errorMsg3: '账号不能为空',
    errorMsg4: '账号格式有误',
    button: '确定',
    msg1: '操作成功'
  },
  Withdraw: {
    pageTitle: '提现',
    title: '提现金额',
    placeholder: '请输入提现金额',
    desc1: '可提现金额',
    desc2: '全部提取',
    item1: '到账账户',
    button: '确定',
    errorMsg1: '金额不能为空',
    errorMsg2: '金额输入不合法',
    errorMsg3: '余额不足',
    msg: '操作成功',
    msg2: '提示',
    msg3: '确定提现吗?'
  },
  WithdrawStatus: {
    pageTitle: '提现',
    status1: '发起提现申请',
    status2: '处理中',
    status3: '到账成功',
    button: '完成'
  },
  Captcha: {
    title: '输入验证码',
    desc1: '验证码已发送至',
    desc2: '重新发送',
    desc3: 's后重新发送',
    errorMsg: '验证码错误',
    msg1: '发送成功',
    msg2: '验证码错误'
  },
  Download: {
    pageTitle: '下载',
    name: '元征设备码',
    desc1: '设备码APP是一款为元征设备的使用者提供方便快速的查阅设备信息、反馈设备意见、使用共享汽修设备服务的移动客户端;',
    desc2: '如您提交的意见被采纳，将会收到一笔奖励金哦，赶快下载使用吧！',
    button: '立即下载'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js